import React from 'react'
import Input from '../Forms/Input'
import Button from '../Forms/Button'
import useForm from '../../Hooks/useForm'
import useFetch from '../../Hooks/useFetch'
import { PASSWORD_LOST } from '../../Api'
import Error from '../Helper/Error'
import Head from '../Helper/Head'

const LoginPasswordRecover = () => {
  const login = useForm()
  const { data, loading, error, request } = useFetch()

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (login.validate()) {
      const { url, options } = PASSWORD_LOST({
        login: login.value,
        url: window.location.href.replace('recover', 'reset')
      })
      const { json } = await request(url, options)
      console.log(json)
    }
  }

  return (
    <section className='animeLeft'>
      <Head title='Recupere sua senha' />
      <h1 className='title'>Perdeu a senha?</h1>
      {data ? (
        <p style={{ color: '#4c1' }}>{data}</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <Input label='Email / Usuário' type='text' name='login' {...login} />
          {loading ? (
            <Button disabled>Enviando...</Button>
          ) : (
            <Button>Enviar Email</Button>
          )}
        </form>
      )}

      <Error error={error} />
    </section>
  )
}

export default LoginPasswordRecover
